/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

// import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../modules/types';

const isNotColor = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'COLOR',
]);

export default [
  ...[
    ['FieldColorPicker', {
      label: null,
      name: 'color_value',
      prefix: 'Color:',
      useAlpha: true,
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotColor, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
